export const UDL_INDEX_EVENT_NAMES = {
  VIEWED_PAGE: 'Viewed Strategy Index'
}
